/**
 * Binary asset helpers (placeholder textures, data-URL decoding).
 */

// 16x16 opaque PNG placeholder (magenta/black checker is overkill; a flat
// neutral tile is fine and users replace it). Base64 of a valid 16x16 PNG.
const PLACEHOLDER_PNG_BASE64 =
  "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKUlEQVR42mNkYGD4z0AEYBxVSFJ" +
  "ihqEKR11JlkKKXUmyC0dDgS7BAABF4gH5w2q8sQAAAABJRU5ErkJggg==";

export function base64ToBytes(base64: string): Uint8Array {
  // atob is available in browsers and in Node 16+ (our test runtime).
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

export function placeholderPng(): Uint8Array {
  return base64ToBytes(PLACEHOLDER_PNG_BASE64);
}

/** Decode a `data:image/png;base64,...` URL to raw bytes. */
export function dataUrlToBytes(dataUrl: string): Uint8Array {
  const comma = dataUrl.indexOf(",");
  if (comma === -1) return placeholderPng();
  const meta = dataUrl.slice(0, comma);
  const payload = dataUrl.slice(comma + 1);
  if (meta.includes(";base64")) return base64ToBytes(payload);
  // URL-encoded text payload.
  const decoded = decodeURIComponent(payload);
  const bytes = new Uint8Array(decoded.length);
  for (let i = 0; i < decoded.length; i++) bytes[i] = decoded.charCodeAt(i);
  return bytes;
}
